import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '@/components/PreLogin/login/Login';
import PreLogin from '@/components/PreLogin/PreLogin';
import PostLogin from '@/components/PostLogin/PostLogin';
import ForgotPassword from '@/components/PreLogin/forgot-password/ForgotPassword';
import ResetPassword from '@/components/PreLogin/reset-password/ResetPassword';
import Tiers from '@/components/Tiers/tiers.vue';
import addTiers from '@/components/Tiers/addTier.vue';
import editTier from '@/components/Tiers/editTier.vue';
import Licences from '@/components/Licences/Licences.vue';
import addLicences from '@/components/Licences/addLicence.vue';
import licenseManager from '@/components/LicenseManager/LicenseManager.vue';
import businessFunction from '@/components/BusinessFunction/businessFunction.vue';
import designations from '@/components/Designations/designations.vue';
import domains from '@/components/Domains/domains.vue';
import departments from '@/components/Departments/departments.vue';
import addLicenceManager from '@/components/LicenseManager/addLicenceManager.vue';
import editLicence from '@/components/Licences/editLicence.vue';
import viewLicence from '@/components/Licences/viewLicence.vue';
import editLicenceManager from '@/components/LicenseManager/editLicenceManager.vue';
import addBusinessFunction from '@/components/BusinessFunction/addBusinessFunction.vue';
import editBusinessFunction from '@/components/BusinessFunction/editBusinessFunction.vue';
import viewBusinessFunction from '@/components/BusinessFunction/viewBusinessFunction.vue';
// import addDesignation from '@/components/Designations/addDesignation.vue';
// import editDesignation from '@/components/Designations/editDesignation.vue';
import addDomain from '@/components/Domains/addDomain.vue';
import editDomain from '@/components/Domains/editDomain.vue';
//import addDepartment from '@/components/Departments/addDepartment.vue';
//import editDepartment from '@/components/Departments/editDepartment.vue';
import profileEdit from '@/components/Profile/profileEdit.vue';
import changePassword from '@/components/changePassword/changePassword.vue';
import valuestreammetrics from '@/components/ValueStreamMetrics/valuestreammetrics.vue';
import Analytics from '@/components/Analytics/Analytics.vue';
import Marketing from '@components/Marketing/Marketing.vue'
import Dashboard from '@components/Dashboard/Dashboard.vue'
Vue.use(VueRouter);

const routes = [
  {
    path: '',
    component: PreLogin,
    children: [
      {
        name: 'Login',
        path: '',
        component: Login,
      },
      {
        name: 'ForgotPassword',
        path: '/forgotpassword',
        component: ForgotPassword,
      },
      {
        name: 'ResetPassword',
        path: '/resetpassword',
        component: ResetPassword,
      },
      // {
      //   name: 'Logout',
      //   path: '/loggedout',
      //   component: Logout,
      // },

    ],
  },
  // {
  //   path: '/',
  //   redirect: {
  //     name: 'Login',
  //   },
  // },
  // {
  //   path: '/login',
  //   name: 'Login',
  //   component: Login,
  // },
  // {
  //   path: '/forgot-password',
  //   name: 'forgotPassword',
  //   component: ForgotPassword,
  // },
  {
    path: '/',
    component: PostLogin,
    children: [
      {
        path: '/licences',
        name: 'Licences',
        component: Licences,
        children: [
          {
            path: 'add-new-licence',
            name: 'addLicences',
            component: addLicences,
          },
          {
            path: 'edit-licence/:id',
            name: 'editLicence',
            component: editLicence,
          },
          {
            path: 'view-licence/:id',
            name: 'viewLicence',
            component: viewLicence
          }
        ],
      },
      {
        path: '/tiers',
        name: 'Tiers',
        component: Tiers,
        children: [
          {
            path: 'add-new-tiers',
            name: 'addTiers',
            component: addTiers,
          },
          {
            path: 'edit-tier/:id',
            name: 'editTier',
            component: editTier,
          },
        ],
      },
      {
        path: '/license-manager',
        name: 'licenseManager',
        component: licenseManager,
        children: [
          {
            path: 'add-new-license-manager',
            name: 'addLicenceManager',
            component: addLicenceManager,
          },
          {
            path: 'edit-licence-Manager/:id',
            name: 'editLicenceManager',
            component: editLicenceManager,
          },
        ],
      },
      {
        path: '/businessfunction',
        name: 'BusinessFunction',
        component: businessFunction,
        children: [
          {
            path: 'add-businessFunction',
            name: 'addBusinessFunction',
            component: addBusinessFunction,
          },
          {
            path: 'edit-businessFunction/:id',
            name: 'editBusinessFunction',
            component: editBusinessFunction,
          },
          {
            path: 'view-businessFunction/:id',
            name: 'viewBusinessFunction',
            component: viewBusinessFunction,
          },
        ],
      },
      {
        path: '/designations',
        name: 'Designations',
        component: designations,
        // children: [
        //   {
        //     path: 'add-designation',
        //     name: 'addDesignation',
        //     component: addDesignation,
        //   },
        //   {
        //     path: 'edit-designation/:id',
        //     name: 'editDesignation',
        //     component: editDesignation,
        //   },
        // ],
      },
      {
        path: '/domains',
        name: 'Domains',
        component: domains,
        children: [
          {
            path: 'add-domain',
            name: 'addDomain',
            component: addDomain,
          },
          {
            path: 'edit-domain/:id',
            name: 'editDomain',
            component: editDomain,
          },
        ],
      },
      {
        path: '/departments',
        name: 'Departments',
        component: departments,
        // children: [
        //   {
        //     path: 'add-department',
        //     name: 'addDepartment',
        //     component: addDepartment,
        //   },
        //   {
        //     path: 'edit-department/:id',
        //     name: 'editDepartment',
        //     component: editDepartment,
        //   },
        // ],
      },
      {
        path: '/profileEdit',
        name: 'profileEdit',
        component: profileEdit,        
      },
      {
        path: '/changePassword',
        name: 'changePassword',
        component: changePassword,        
      },
      {
        path: '/ValueStreamMetrics',
        name: 'valuestreammetrics',
        component: valuestreammetrics,        
      },
      {
        path: '/Analytics',
        name: 'Analytics',
        component: Analytics,        
      },
      {
        path: '/RegistrationConfiguration',
        name: 'Marketing',
        component: Marketing,        
      },
      {
        path: '/Dashboard',
        name: 'Dashboard',
        component: Dashboard,        
      },
      
    ],
  },
  // {
  //   path: '/tiers',
  //   name: 'Tiers',
  //   component: Tiers,
  //   children: [
  //     {
  //       path: 'add-new-tiers',
  //       name: 'addTiers',
  //       component: addTiers,
  //     },
  //   ],
  // },
  // {
  //   path: '/licences',
  //   name: 'Licences',
  //   component: Licences,
  //   children: [
  //     {
  //       path: 'add-new-licence',
  //       name: 'addLicences',
  //       component: addLicences,
  //     },
  //   ],
  // },
  // {
  //   path: '/add-licences',
  //   name: 'addLicences',
  //   component: addLicences
  // },
  // {
  //   path: '/license-manager',
  //   name: 'licenseManager',
  //   component: licenseManager,
  //   children: [
  //     {
  //       path: 'add-new-license-manager',
  //       name: 'addLicenceManager',
  //       component: addLicenceManager,
  //     },
  //   ],
  // },
  // {
  //   path: '/add-license-manager',
  //   name: 'addLicenceManager',
  //   component: addLicenceManager
  // }
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
